/**
 * @generated SignedSource<<b609960fcb863863b0f519d12810f748>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DisplayPromoCodeWrapper_viewer$data = {
  readonly activePromotion: {
    readonly isShippingPromotion: boolean | null;
    readonly " $fragmentSpreads": FragmentRefs<"DisplayPromoCode_promotion">;
  } | null;
  readonly item?: {
    readonly " $fragmentSpreads": FragmentRefs<"DisplayPromoCode_item">;
  } | null;
  readonly user?: {
    readonly " $fragmentSpreads": FragmentRefs<"DisplayPromoCode_user">;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"DisplayPromoCode_viewer">;
  readonly " $fragmentType": "DisplayPromoCodeWrapper_viewer";
};
export type DisplayPromoCodeWrapper_viewer$key = {
  readonly " $data"?: DisplayPromoCodeWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"DisplayPromoCodeWrapper_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "hasItemId"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId"
    },
    {
      "kind": "RootArgument",
      "name": "itemId"
    },
    {
      "kind": "RootArgument",
      "name": "optionalItemId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "DisplayPromoCodeWrapper_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DisplayPromoCode_viewer"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "itemId",
          "variableName": "optionalItemId"
        },
        (v0/*: any*/)
      ],
      "concreteType": "Promotion",
      "kind": "LinkedField",
      "name": "activePromotion",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DisplayPromoCode_promotion"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isShippingPromotion",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "hasUserId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            (v0/*: any*/)
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "DisplayPromoCode_user"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "condition": "hasItemId",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "itemId",
              "variableName": "itemId"
            },
            {
              "kind": "Literal",
              "name": "pageType",
              "value": "PROMO"
            }
          ],
          "concreteType": "Item",
          "kind": "LinkedField",
          "name": "item",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "DisplayPromoCode_item"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "5989e9539a3804f9920cc4fd51a5fb1b";

export default node;
